import { commandsManager } from '../../App';
import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';
import * as TYPES from './types';

export const setActiveButtonIds = (payload = []) => {
  return {
    type: TYPES.SET_ACTIVE_BUTTON_IDS,
    payload,
  };
};

export const handleButton = (buttonId = 'OriginWin') => {
  const buttons = {
    OriginWin: 'resetViewport',
    BoneWin: 'boneViewport',
    LungWin: 'lungViewport',
    MediastinumWin: 'mediastinumViewport',
  };
  if (!Object.keys(buttons).includes(buttonId)) buttonId = 'OriginWin';
  commandsManager.runCommand(buttons[buttonId]);
  return setActiveButtonIds([buttonId]);
};

export const setLevels = ({ windowWidth, windowCenter }) => (
  dispatch,
  getState
) => {
  const {
    preferences: { windowLevelData },
    viewports,
  } = getState();
  const windowGroup = Object.values(windowLevelData).reduce(
    (acc, item) =>
      Object.assign(acc, {
        [`${item.window}:${item.level}`]: item.description,
      }),
    {}
  );
  const key = windowGroup[`${windowWidth}:${windowCenter}`];
  if (key) {
    let [buttonId] = key.match(/^([a-z]|[A-Z])+/) || [];
    if (buttonId) {
      if (!buttonId.includes('Win')) buttonId += 'Win';
      dispatch(handleButton(buttonId));
    }
  }

  const enabledElement =
    cornerstoneTools.store.state.enabledElements[viewports.activeViewportIndex];
  if (enabledElement) {
    let viewport = cornerstone.getViewport(enabledElement);
    if (typeof windowWidth === 'number') viewport.voi.windowWidth = windowWidth;
    if (typeof windowCenter === 'number')
      viewport.voi.windowCenter = windowCenter;
    cornerstone.setViewport(enabledElement, viewport);
  }
};
